export default {
  loading: false,
  form: {
    file: null,
  },
  files: [],
  filesCount: null,
  fileType: 'order',
  currentPage: 1,
  perPage: 10,
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-importer/store/states.js